<template>
  <div class="strip" role="img" :aria-label="`最近 ${cells.length} 小时在线情况`">
    <span
      v-for="(cell, i) in cells"
      :key="i"
      class="cell"
      :class="{ 'day-start': isDayStart(i) }"
      :style="{ background: stripCellColor(cell) }"
      :title="stripCellTitle(cell, hourOf(i))"
    />
  </div>
</template>

<script setup lang="ts">
import type { HealthStripCell } from '../types';
import { stripCellColor, stripCellHour, stripCellTitle } from './healthPresentation';

const props = defineProps<{ cells: (HealthStripCell | null)[]; generatedAt: string }>();

const hourOf = (index: number) => stripCellHour(props.generatedAt, index, props.cells.length);
// A small gap before each local midnight makes the days easy to count.
const isDayStart = (index: number) => index > 0 && hourOf(index).getHours() === 0;
</script>

<style scoped>
.strip { display: flex; align-items: stretch; height: 16px; }
.cell { flex: 0 0 2px; margin-right: 0; }
.cell.day-start { margin-left: 3px; }
</style>
